// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"c7276650a0dbf7e3401e","488":"e10ca2b9f3f78b61ad33","532":"8bbf4a81c065a9b9699d","592":"45071c695e091bd73b16","736":"ace27d1da9055fb3bce7"}[chunkId] + ".js";
};